import { QueryFunctionContext } from '@tanstack/react-query';

import { GET_WITH_CREDENTIALS } from '~/api';
import { ProductConfigurationApiUrl } from '~/api/urls';
import { IProductConfiguration } from '~/domain/IProductConfiguration';

//export const getProductConfiguration = async (props: any) => { // (context: QueryFunctionContext<[string, { market: string, vehicle: string }]>) => {
export const getProductConfiguration = async (context: QueryFunctionContext<[string, { requestId: string }]>) => {
  const params = context.queryKey[1];
  const url = ProductConfigurationApiUrl.expand(params);
  try {
    return await GET_WITH_CREDENTIALS<IProductConfiguration>(url);
  } catch (e) {
    return {};
  }
}
